import script from "./CreateSubAccountSuccessModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateSubAccountSuccessModal.vue?vue&type=script&setup=true&lang=js"

import "./CreateSubAccountSuccessModal.vue?vue&type=style&index=0&id=4b71caa3&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b71caa3"]])

export default __exports__